<script setup lang="ts"></script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="38" viewBox="0 0 36 38" fill="none">
        <path
            d="M17.9976 7.76615C17.9976 7.76615 11.2784 0.754892 3.94191 5.8597C-4.22066 11.54 1.78405 20.5584 8.5033 26.9539C13.9846 32.1724 17.4421 36.6093 17.9964 37.6549V7.76615H17.9976Z"
            fill="#C21024"
        />
        <path
            d="M18.002 7.76615C18.002 7.76615 24.7212 0.754892 32.0577 5.8597C40.2203 11.54 34.2155 20.5584 27.4963 26.9539C22.015 32.1724 18.5574 36.6093 18.0031 37.6549V7.76615H18.002Z"
            fill="#B0AFAF"
        />
        <path
            d="M18.002 7.76613C18.002 7.76613 24.3188 -1.82773 29.2173 3.27708C34.6677 8.95737 28.828 20.5583 24.3402 26.955C20.6797 32.1735 18.3723 36.6105 18.002 37.6561V7.76613Z"
            fill="#727272"
        />
        <path
            d="M18.002 7.76613C18.002 7.76613 21.6114 -3.42631 23.8547 1.67731C26.3509 7.3576 22.9586 20.5583 20.904 26.9538C19.2281 32.1723 18.1717 36.6093 18.002 37.6549V7.76613Z"
            fill="#434142"
        />
    </svg>
</template>
